
import HelperGenerics from './HelperGenerics';

/*
 * criteria helpers
 */

class HelperCriteriaCalculator {

	static getFlatSvcKeyObj(svc) {
		const svcCode = svc.serviceCode;
		const pckCode = svc.packageCode;
		if (svcCode && pckCode) {
			return `${pckCode}-${svcCode}`;
		}
		return HelperCriteriaCalculator.getFlatSvcKey(svcCode, pckCode);
	}
	static getFlatSvcKey(serviceCode, packageCode) {
		if (packageCode != null) {
			return `${packageCode}-${serviceCode}`;
		}
		return serviceCode;
	}

	static getCriteriaLimit(mapServices, duration, annualMileage) {
		var durMinSvc = null;
		var durMaxSvc = null;
		var kmanMinSvc = null;
		var kmanMaxSvc = null;
		for (var code in mapServices) {
			var svcElt = mapServices[code];
			if (svcElt.selected && svcElt.bounds != null && svcElt.bounds[0] != null) {
				durMinSvc = HelperGenerics.maxOrNullBetweenBounds(durMinSvc, svcElt.bounds[0].durations.min);
				durMaxSvc = HelperGenerics.minOrNullBetweenBounds(durMaxSvc, svcElt.bounds[0].durations.max);
				if (svcElt.bounds[0].annualMileages != null) {
					kmanMinSvc = HelperGenerics.maxOrNullBetweenBounds(kmanMinSvc, svcElt.bounds[0].annualMileages.min);
					kmanMaxSvc = HelperGenerics.minOrNullBetweenBounds(kmanMaxSvc, svcElt.bounds[0].annualMileages.max);
				}
				var resultWithGlobalMileages = HelperCriteriaCalculator.buildCriteriaLimitsWithGlobalMileages(svcElt, duration, annualMileage,
					durMinSvc, durMaxSvc, kmanMinSvc, kmanMaxSvc);
				durMinSvc = resultWithGlobalMileages.durMinSvc;
				durMaxSvc = resultWithGlobalMileages.durMaxSvc;
				kmanMinSvc = resultWithGlobalMileages.kmanMinSvc;
				kmanMaxSvc = resultWithGlobalMileages.kmanMaxSvc;
			}
		}
		return { durMinSvc: durMinSvc, durMaxSvc: durMaxSvc, kmanMinSvc: kmanMinSvc, kmanMaxSvc: kmanMaxSvc };
	}
	static buildCriteriaLimitsWithGlobalMileages(svcElt, duration, annualMileage, durMinSvc, durMaxSvc, kmanMinSvc, kmanMaxSvc) {
		if (svcElt.bounds[0].globalMileages != null) {
			if (svcElt.bounds[0].globalMileages.min !== null) {
				var kmMin = svcElt.bounds[0].globalMileages.min * 12.0 / (duration * 1.0);
				kmanMinSvc = HelperGenerics.maxOrNullBetweenBounds(kmanMinSvc, kmMin);
				var durMin = svcElt.bounds[0].globalMileages.min * 12.0 / (annualMileage * 1.0);
				durMinSvc = HelperGenerics.maxOrNullBetweenBounds(durMinSvc, durMin);
			}
			if (svcElt.bounds[0].globalMileages.max !== null) {
				var kmMax = svcElt.bounds[0].globalMileages.max * 12.0 / (duration * 1.0);
				kmanMaxSvc = HelperGenerics.minOrNullBetweenBounds(kmanMaxSvc, kmMax);
				var durMax = svcElt.bounds[0].globalMileages.max * 12.0 / (annualMileage * 1.0);
				durMaxSvc = HelperGenerics.minOrNullBetweenBounds(durMaxSvc, durMax);
			}
		}
		return { durMinSvc: durMinSvc, durMaxSvc: durMaxSvc, kmanMinSvc: kmanMinSvc, kmanMaxSvc: kmanMaxSvc }
	}

	static getServiceMap(packageData, serviceData, parameters) {
		var serviceMap = {};
		var duration = parameters.duration;
		var annualMileage = parameters.annualMileage;
		var globalMileage = parameters.globalMileage;
		let pack;
		for (var pckKey in packageData) {
			pack = packageData[pckKey];
			var subServiceList = pack.services;
			var boundSons = null;
			if (subServiceList != null && subServiceList.length > 0) {
				for (var subSvcKey in subServiceList) {
					var subService = subServiceList[subSvcKey];
					var serviceKey = HelperCriteriaCalculator.getFlatSvcKey(subService.serviceCode, pack.packageCode);
					serviceMap[serviceKey] = {
						packageCode: pack.packageCode, serviceCode: subService.serviceCode, selected: subService.defaultIncluded === true,
						bounds: subService.bounds, isService: true
					};
					serviceMap[serviceKey]['selectable'] = HelperCriteriaCalculator.isSelectableCriteria(serviceMap[serviceKey], duration, annualMileage, globalMileage);
					boundSons = HelperCriteriaCalculator.getUnionBounds(boundSons, subService.bounds);
				}
			}
			serviceMap[pack.packageCode] = { selected: pack.defaultIncluded === true, bounds: boundSons };
			serviceMap[pack.packageCode]['selectable'] = HelperCriteriaCalculator.isSelectableCriteria(serviceMap[pack.packageCode], duration, annualMileage, globalMileage);
		}
		for (var svcKey in serviceData) {
			var service = serviceData[svcKey];
			serviceMap[HelperCriteriaCalculator.getFlatSvcKeyObj(service)] = {
				selected: service.defaultIncluded === true, bounds: service.bounds, isService: true,
				serviceCode: service.serviceCode
			};
			serviceMap[HelperCriteriaCalculator.getFlatSvcKeyObj(service)]['selectable'] = HelperCriteriaCalculator.isSelectableCriteria(
				HelperCriteriaCalculator.getFlatSvcKeyObj(service), duration, annualMileage, globalMileage);
		}
		HelperCriteriaCalculator.includedServicesFromParametersInSvcMap(serviceMap, parameters, packageData, duration, annualMileage, globalMileage, pack);
		return serviceMap;
	}

	static includedServicesFromParametersInSvcMap(serviceMap, parameters, packageData,
		duration, annualMileage, globalMileage, pack) {
		if (parameters.services != null) {
			var packSelectedMap = {};
			for (var pckKey1 in packageData) {
				packSelectedMap[packageData[pckKey1].packageCode] = false;
			}
			for (var svcKeyParam in parameters.services) {
				var serviceParam = parameters.services[svcKeyParam];
				var serviceKey = HelperCriteriaCalculator.getFlatSvcKeyObj(serviceParam);
				HelperCriteriaCalculator.includeOneServiceFromParametersToSvcMap(serviceMap, packSelectedMap, serviceKey, pack, serviceParam,
					{ duration: duration, annualMileage: annualMileage, globalMileage: globalMileage });
			}
			for (var packSelectedKey in packSelectedMap) {
				serviceMap[packSelectedKey]['selected'] = packSelectedMap[packSelectedKey];
			}
		}
	}

	static includeOneServiceFromParametersToSvcMap(serviceMap, packSelectedMap, serviceKey, pack, serviceParam, currentDurationMileage) {
		const duration = currentDurationMileage.duration;
		const annualMileage = currentDurationMileage.annualMileage;
		const globalMileage = currentDurationMileage.globalMileage;
		if (serviceMap[serviceKey] != null) {
			var isSelectable = HelperCriteriaCalculator.isSelectableCriteria(serviceMap[serviceKey], duration, annualMileage, globalMileage);
			var included = (serviceParam.included === true && isSelectable);
			var packageCode = serviceParam.packageCode;
			var serviceCode = serviceParam.serviceCode;
			var boundsMap = serviceMap[serviceKey]['bounds'];
			if (packageCode != null) {
				serviceMap[serviceKey] = {
					packageCode: packageCode, selected: included, selectable: isSelectable, bounds: boundsMap, isService: true,
					serviceCode: serviceCode
				};
				if (packSelectedMap[packageCode] == null) {
					packSelectedMap[packageCode] = included;
				} else {
					packSelectedMap[packageCode] = included || (pack && pack.packageCode && packSelectedMap[pack.packageCode]);
				}
			} else {
				serviceMap[serviceKey] = {
					selected: included, selectable: isSelectable, bounds: boundsMap, isService: true,
					serviceCode: serviceCode
				};
			}
		}
	}

	static getServiceLevelsFiltered(serviceMap, serviceLevelsData) {
		const serviceLevelsFiltered = { levels: [], services: [] };
		if (!serviceLevelsData || !serviceMap) {
			return null;
		}
		const serviceFlatMap = {};
		const selectedList = [];
		const selectableList = [];
		Object.keys(serviceMap).forEach(
			function (k) {
				if (serviceMap[k]) {
					if (serviceMap[k] && serviceMap[k].isService) {
						HelperCriteriaCalculator.buildServiceLevelFilteredFlatMapAndSelectedSelectableLists(serviceMap[k], serviceFlatMap, selectedList, selectableList);
					} else {
						Object.keys(serviceMap[k]).forEach(
							function (ks) {
								if (serviceMap[k][ks] && serviceMap[k][ks].isService) {
									HelperCriteriaCalculator.buildServiceLevelFilteredFlatMapAndSelectedSelectableLists(serviceMap[k][ks], serviceFlatMap, selectedList, selectableList);
								}
							}
						);
					}
				}
			}
		);
		HelperCriteriaCalculator.buildServiceLevelFilteredPushLevels(serviceLevelsFiltered, serviceLevelsData, serviceFlatMap, selectedList, selectableList);
		HelperCriteriaCalculator.buildServiceLevelFilteredPushServices(serviceLevelsFiltered, serviceLevelsData, serviceFlatMap);
		return serviceLevelsFiltered;
	}

	static buildServiceLevelFilteredFlatMapAndSelectedSelectableLists(servicesRecord, serviceFlatMap, selectedList, selectableList) {
		const svcKeyObj = { serviceCode: servicesRecord.serviceCode, packageCode: servicesRecord.packageCode };
		const flatKey = HelperCriteriaCalculator.getFlatSvcKeyObj(svcKeyObj);
		serviceFlatMap[flatKey] = servicesRecord;
		if (servicesRecord.selected) {
			selectedList.push(flatKey);
		}
		if (servicesRecord.selectable) {
			selectableList.push(flatKey);
		}
	}

	static buildServiceLevelFilteredPushLevels(serviceLevelsFiltered, serviceLevelsData, serviceFlatMap, selectedList, selectableList) {
		if (serviceLevelsData.levels) {
			for (const levelKey in serviceLevelsData.levels) {
				const level = serviceLevelsData.levels[levelKey];
				const isNoService = !level.services || level.services.length === 0;
				const isAvailable = isNoService || level.services.every((s) => serviceFlatMap.hasOwnProperty(HelperCriteriaCalculator.getFlatSvcKeyObj(s)));
				const isSelected = (isNoService && selectedList.length === 0)
					|| (!isNoService && level.services.every((s) => selectedList.includes(HelperCriteriaCalculator.getFlatSvcKeyObj(s))));
				const isSelectable = isNoService || level.services.every((s) => selectableList.includes(HelperCriteriaCalculator.getFlatSvcKeyObj(s)));
				if (isAvailable && isSelectable) {
					serviceLevelsFiltered.levels.push({ ...level, selected: isSelected, selectable: isSelectable });
				}
			}
		}
	}
	static buildServiceLevelFilteredPushServices(serviceLevelsFiltered, serviceLevelsData, serviceFlatMap) {
		if (serviceLevelsData.services) {
			for (const svcKey in serviceLevelsData.services) {
				const serviceData = serviceLevelsData.services[svcKey];
				const serviceFlatKey = HelperCriteriaCalculator.getFlatSvcKeyObj(serviceData);
				const isAvailable = serviceFlatMap.hasOwnProperty(serviceFlatKey);
				if (isAvailable && serviceFlatMap[serviceFlatKey].selectable) {
					serviceLevelsFiltered.services.push({
						...serviceData,
						selected: serviceFlatMap[serviceFlatKey].selected,
						selectable: serviceFlatMap[serviceFlatKey].selectable,
						svcFlatKey: serviceFlatKey
					});
				}
			}
		}
	}

	static getServiceParameters(serviceMap) {
		var serviceParameters = [];
		for (var svcKey in serviceMap) {
			var eltSvc = serviceMap[svcKey];
			if (eltSvc.selectable && eltSvc.isService) {
				var paramService = { serviceCode: eltSvc.serviceCode };
				if (eltSvc.packageCode != null) {
					paramService.packageCode = eltSvc.packageCode;
				}
				paramService.included = eltSvc.selected;
				serviceParameters.push(paramService);
			}
		}
		return serviceParameters;
	}


	static getBoundedDurations(durations, serviceMap, annualMileage) {
		if (durations == null) {
			return null;
		}
		let minBound = -1;
		let maxBound = 999999;
		const newDurations = { ...durations };
		let minMaxBound = {};
		Object.keys(serviceMap).forEach(
			function (k) {
				if (serviceMap[k]) {
					if (serviceMap[k] && serviceMap[k].isService) {
						minMaxBound = HelperCriteriaCalculator.findMinMaxForService(serviceMap[k], minMaxBound);
					} else {
						Object.keys(serviceMap[k]).forEach(
							function (ks) {
								minMaxBound = HelperCriteriaCalculator.findMinMaxForService(serviceMap[k][ks], minMaxBound);
							}
						);
					}
				}
			}
		);
		if (minMaxBound.minBound && minMaxBound.maxBound) {
			minBound = minMaxBound.minBound;
			maxBound = minMaxBound.maxBound;
		}
		HelperCriteriaCalculator.boundDurations(newDurations, minBound, maxBound);
		HelperCriteriaCalculator.boundDurationsForServicesAreas(newDurations, serviceMap, annualMileage);
		return newDurations;
	}

	static boundDurationsForServicesAreas(newDurations, serviceMap, annualMileage) {
		for (const svcKey in serviceMap) {
			if (serviceMap[svcKey].bounds != null && serviceMap[svcKey].bounds[0] != null && serviceMap[svcKey].bounds[0].serviceCalculationArea != null
				&& serviceMap[svcKey].bounds[0].serviceCalculationArea.annualMileageToDurationsMap != null
				&& serviceMap[svcKey].bounds[0].serviceCalculationArea.annualMileageToDurationsMap[annualMileage] != null
				&& newDurations.values) {
				const filteredDurationsValues = [];
				for (const durKey in newDurations.values) {
					if (serviceMap[svcKey].bounds[0].serviceCalculationArea.annualMileageToDurationsMap[annualMileage].includes(
						newDurations.values[durKey])) {
						filteredDurationsValues.push(newDurations.values[durKey]);
					}
				}
				newDurations.values = filteredDurationsValues;
			}
		}
	}

	static getBoundedMileages(mileages, serviceMap, duration) {
		HelperCriteriaCalculator.boundMileagesForServicesAreas(mileages, serviceMap, duration);
		return mileages;
	}

	static boundMileagesForServicesAreas(mileages, serviceMap, duration) {
		const mileageValues = HelperCriteriaCalculator.buildMileageValuesFromMinMaxStep(mileages);
		for (const svcKey in serviceMap) {
			if (serviceMap[svcKey].bounds != null && serviceMap[svcKey].bounds[0] != null && serviceMap[svcKey].bounds[0].serviceCalculationArea != null
				&& serviceMap[svcKey].bounds[0].serviceCalculationArea.durationToAnnualMileagesMap != null
				&& serviceMap[svcKey].bounds[0].serviceCalculationArea.durationToAnnualMileagesMap[duration] != null
				&& mileageValues
				&& mileages.annual) {
				const filteredMileagesValues = [];
				for (const mileageKey in mileageValues) {
					if (serviceMap[svcKey].bounds[0].serviceCalculationArea.durationToAnnualMileagesMap[duration].includes(
						mileageValues[mileageKey])) {
						filteredMileagesValues.push(mileageValues[mileageKey]);
					}
				}
				mileages.values = filteredMileagesValues;
				mileages.min = null;
				mileages.max = null;
				mileages.step = null;
			}
		}
	}

	static buildMileageValuesFromMinMaxStep(mileages) {
		if (mileages) {
			if (mileages.min && mileages.max && mileages.step && mileages.min <= mileages.max && mileages.step > 0) {
				const mileageValues = [];
				for (let i = mileages.min; i <= mileages.max; i += mileages.step) {
					mileageValues.push(i);
				}
				return mileageValues;
			}
			return mileages.values;
		}
		return null;
	}

	static findMinMaxForService(serviceRecord, minMaxBound) {
		if (serviceRecord && serviceRecord.isService && serviceRecord.selected) {
			if (serviceRecord.bounds && serviceRecord.bounds[0] && serviceRecord.bounds[0].durations) {
				minMaxBound['minBound'] = serviceRecord.bounds[0].durations.min;
				minMaxBound['maxBound'] = serviceRecord.bounds[0].durations.max;
			}
		}
		return minMaxBound;
	}

	static boundDurations(durations, minBound, maxBound) {
		if (durations.step) {
			HelperCriteriaCalculator.boundDurationSteps(durations, minBound, maxBound);
		} else {
			if (durations.min && durations.min < minBound) {
				durations.min = minBound;
			}
			if (durations.max && durations.max > maxBound) {
				durations.max = maxBound;
			}
		}
		if (durations.values) {
			const newValues = [];
			durations.values.forEach(
				function (dur) {
					if (dur >= minBound && dur <= maxBound) {
						newValues.push(dur);
					}
				}
			);
			durations.values = newValues;
		}
	}

	static boundDurationSteps(durations, minBound, maxBound) {
		if (durations.min) {
			let newMin = durations.min;
			while (newMin < minBound) {
				newMin += durations.step;
			}
			durations.min = newMin;
		}
		if (durations.max) {
			let newMax = durations.max;
			while (newMax > maxBound) {
				newMax -= durations.step;
			}
			durations.max = newMax;
		}
	}

	static isSelectableCriteria(svcElt, duration, annualMileage, globalMileage) {
		if (svcElt.bounds == null || svcElt.bounds[0] == null) {
			return true;
		}
		var result = true;
		if (duration != null) {
			if (svcElt.bounds[0].durations.min != null) {
				result = result && duration >= svcElt.bounds[0].durations.min;
			}
			if (svcElt.bounds[0].durations.max != null) {
				result = result && duration <= svcElt.bounds[0].durations.max;
			}
		}
		const isAnnualMileagesMin = svcElt.bounds[0].annualMileages != null && svcElt.bounds[0].annualMileages.min != null;
		const isAnnualMileagesMax = svcElt.bounds[0].annualMileages != null && svcElt.bounds[0].annualMileages.max != null;
		const isGlobalMileagesMin = svcElt.bounds[0].globalMileages != null && svcElt.bounds[0].globalMileages.min != null;
		const isGlobalMileagesMax = svcElt.bounds[0].globalMileages != null && svcElt.bounds[0].globalMileages.max != null;
		const isMileageMin = isAnnualMileagesMin || isGlobalMileagesMin;
		const isMileageMax = isAnnualMileagesMax || isGlobalMileagesMax;
		result = HelperCriteriaCalculator.isSelectableCriteriaForKm(result, isMileageMin, isGlobalMileagesMin, { minOrMax: 'min', annualOrGlobalMileages: 'annualMileages' },
			svcElt, duration, annualMileage);
		result = HelperCriteriaCalculator.isSelectableCriteriaForKm(result, isMileageMax, isGlobalMileagesMax, { minOrMax: 'max', annualOrGlobalMileages: 'annualMileages' },
			svcElt, duration, annualMileage);
		result = HelperCriteriaCalculator.isSelectableCriteriaForKm(result, isMileageMin, isAnnualMileagesMin, { minOrMax: 'min', annualOrGlobalMileages: 'globalMileages' },
			svcElt, duration, globalMileage);
		result = HelperCriteriaCalculator.isSelectableCriteriaForKm(result, isMileageMax, isAnnualMileagesMax, { minOrMax: 'max', annualOrGlobalMileages: 'globalMileages' },
			svcElt, duration, globalMileage);
		return result;
	}

	static isSelectableCriteriaForKm(result, isMileageMinOrMax, isGlobalMileageMinOrMax, caseMinMaxGlobalAnnual, svcElt, duration, mileage) {
		const minOrMax = caseMinMaxGlobalAnnual.minOrMax;
		const annualOrGlobalMileages = caseMinMaxGlobalAnnual.annualOrGlobal;
		let opositeExtremum = Math.max;
		let comparison = (value, extremum) => {
			return value >= extremum
		}
		let calculateAnnualOrGlobal = (svcElt, duration) => {
			return Math.round(svcElt.bounds[0].globalMileages[minOrMax] * 12.0 / (duration * 1.0));
		}
		if (minOrMax === 'max') {
			opositeExtremum = Math.min;
			comparison = (value, extremum) => {
				return value <= extremum
			}
		}
		if (annualOrGlobalMileages === 'globalMileages') {
			calculateAnnualOrGlobal = (svcElt, duration) => {
				return Math.round(svcElt.bounds[0].annualMileages[minOrMax] * duration * 1.0 / 12.0);
			}
		}
		if (isMileageMinOrMax && mileage != null) {
			var kmExtremum = svcElt.bounds[0][annualOrGlobalMileages] != null ? svcElt.bounds[0][annualOrGlobalMileages][minOrMax] : null;
			if (isGlobalMileageMinOrMax && duration != null) {
				var kmBoundExtremum = calculateAnnualOrGlobal(svcElt, duration);
				kmExtremum = kmExtremum == null ? kmBoundExtremum : opositeExtremum(kmBoundExtremum, kmExtremum);
			}
			result = result && comparison(mileage, kmExtremum);
		}
		return result;
	}

	static getUnionBounds(boundRef, boundSon) {
		if (boundSon == null) {
			return { durMin: null, durMax: null, kmanMin: null, kmanMax: null };
		}
		if (boundRef == null) {
			return boundSon;
		}
		var durMin = HelperGenerics.minOrNullIfOneNull(boundRef.durMin, boundSon.durMin);
		var durMax = HelperGenerics.maxOrNullIfOneNull(boundRef.durMax, boundSon.durMax);
		var kmanMin = HelperGenerics.minOrNullIfOneNull(boundRef.kmanMin, boundSon.kmanMin);
		var kmanMax = HelperGenerics.maxOrNullIfOneNull(boundRef.kmanMax, boundSon.kmanMax);
		var kmgsMin = HelperGenerics.minOrNullIfOneNull(boundRef.kmgsMin, boundSon.kmgsMin);
		var kmgsMax = HelperGenerics.maxOrNullIfOneNull(boundRef.kmgsMax, boundSon.kmgsMax);
		return { durMin: durMin, durMax: durMax, kmanMin: kmanMin, kmanMax: kmanMax, kmgsMin: kmgsMin, kmgsMax: kmgsMax }
	}

	static getDepositParametersWithDefaultAmount(deposits, vehicle, amountNature) {
		if (deposits != null && deposits.defaultAmount != null && deposits.amountKind === 'PCT') {
			var otr = HelperCriteriaCalculator.buildOtrPriceWithOptions(vehicle, amountNature);
			if (otr != null) {
				otr = HelperCriteriaCalculator.addOtrCostsToOtrPrice(otr, vehicle, amountNature);
				deposits.defaultValue = Math.round(deposits.defaultAmount * 1000.0 * 100.0 / otr) / 1000.0;
				if (deposits.min != null && deposits.max != null && deposits.step != null) {
					var values = HelperCriteriaCalculator.buildDepositValuesFromMinMaxSteps(deposits);
					deposits.values = values;
					deposits.min = null;
					deposits.max = null;
					deposits.step = null;
				}
				if (deposits.values != null && !deposits.values.includes(deposits.defaultValue)) {
					deposits.values.push(deposits.defaultValue);
				}
			}
		}
		return deposits;
	}

	static buildDepositValuesFromMinMaxSteps(deposits) {
		var values = [];
		for (var val = deposits.min; val <= deposits.max; val += deposits.step) {
			values.push(val);
		}
		return values;
	}

	static buildOtrPriceWithOptions(vehicle, amountNature) {
		var otr = null;
		var fieldNameAmount = null;
		if (amountNature === 'TC') {
			fieldNameAmount = 'netPriceInclTax';
		} else if (amountNature === 'HT') {
			fieldNameAmount = 'netPriceExclTax';
		}
		if (fieldNameAmount != null && vehicle.pricing[fieldNameAmount] != null) {
			otr = vehicle.pricing[fieldNameAmount];
			if (vehicle.options != null) {
				for (var i in vehicle.options) {
					var optPrx = vehicle.options[i].pricing[fieldNameAmount];
					if (optPrx != null) {
						otr += optPrx;
					}
				}
			}
		}
		return otr;
	}

	static addOtrCostsToOtrPrice(otr, vehicle, amountNature) {
		otr = HelperCriteriaCalculator.addFiscalPropertiesToOtrPrice(otr, vehicle);
		otr = HelperCriteriaCalculator.addOtrCostsExclTaxToOtrPrice(otr, vehicle, amountNature);
		otr = HelperCriteriaCalculator.addOtrCostsInclTaxToOtrPrice(otr, vehicle, amountNature);
		return otr;
	}

	static addFiscalPropertiesToOtrPrice(otr, vehicle) {
		if (vehicle.fiscalProperties != null) {
			if (vehicle.fiscalProperties.registrationFees != null) {
				otr += vehicle.fiscalProperties.registrationFees;
			}
			if (vehicle.fiscalProperties.roadFundLicence != null) {
				otr += vehicle.fiscalProperties.roadFundLicence;
			}
		}
		otr *= 1.0;
		return otr;
	}
	static addOtrCostsExclTaxToOtrPrice(otr, vehicle, amountNature) {
		if (vehicle.otrCosts != null && amountNature === 'HT') {
			if (vehicle.otrCosts.netTransportFees != null
				&& vehicle.otrCosts.netTransportFees.amountExclTax != null) {
				otr += vehicle.otrCosts.netTransportFees.amountExclTax;
			}
			if (vehicle.otrCosts.delivery != null
				&& vehicle.otrCosts.delivery.amountExclTax != null) {
				otr += vehicle.otrCosts.delivery.amountExclTax;
			}
			if (vehicle.otrCosts.transformation != null
				&& vehicle.otrCosts.transformation.amountExclTax != null) {
				otr += vehicle.otrCosts.transformation.amountExclTax;
			}
		}
		otr *= 1.0;
		return otr;
	}
	static addOtrCostsInclTaxToOtrPrice(otr, vehicle, amountNature) {
		if (vehicle.otrCosts != null && amountNature === 'TC') {
			if (vehicle.otrCosts.netTransportFees != null
				&& vehicle.otrCosts.netTransportFees.amountInclTax != null) {
				otr += vehicle.otrCosts.netTransportFees.amountInclTax;
			}
			if (vehicle.otrCosts.delivery != null
				&& vehicle.otrCosts.delivery.amountInclTax != null) {
				otr += vehicle.otrCosts.delivery.amountInclTax;
			}
			if (vehicle.otrCosts.transformation != null
				&& vehicle.otrCosts.transformation.amountInclTax != null) {
				otr += vehicle.otrCosts.transformation.amountInclTax;
			}
		}
		otr *= 1.0;
		return otr;
	}
}

export default HelperCriteriaCalculator;
